import { useState } from 'react';

import { ProductType } from '@generated/gql/graphql';
import { UpdatedTariffModalVariant } from '@src/types/bundle';

import { BasketProviderProps, UpdatedTariffModalState } from '../types';
import { UpdatedTariffModalContext } from './Context';

const UpdatedTariffModalProvider = ({ children }: BasketProviderProps) => {
  const [modalState, setModalState] = useState<UpdatedTariffModalState>({
    changedServices: null,
    variant: UpdatedTariffModalVariant.initial,
  });

  return (
    <UpdatedTariffModalContext
      value={{
        modalState,
        setModalState: (
          variant: UpdatedTariffModalVariant,
          services?: ProductType[]
        ) =>
          setModalState({
            changedServices: services ?? null,
            variant,
          }),
        resetModalState: () =>
          setModalState({
            changedServices: null,
            variant: UpdatedTariffModalVariant.initial,
          }),
      }}
    >
      {children}
    </UpdatedTariffModalContext>
  );
};

export { UpdatedTariffModalProvider };
